import {
  IFilterData,
  IGetFilterProps,
  IGetUniqueData,
} from "interfaces/FilterProps";
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";
import { ISubclientRegisterParams, ISubclientUpdateParams, ISuperficialClient } from "interfaces/SubClient";
import readXlsxFile from "read-excel-file";
import { client } from "./api";

export async function getSubClients({
  order,
  relations,
  skip,
  take,
  where,
}: IGetFilterProps<ISuperficialClient>): Promise<
  IFilterData<ISuperficialClient>
> {
  const api = client();
  const response = await api.get<IFilterData<ISuperficialClient>>(
    "superficial/clients",
    {
      params: {
        take,
        skip,
        relations: JSON.stringify(relations),
        order: JSON.stringify(order),
        where: JSON.stringify(where),
      },
    }
  );
  return response.data;
}

export async function getSubClient(
  id: string
): Promise<IGetUniqueData<ISuperficialClient>> {
  const api = client();
  const response = await api.get<IGetUniqueData<ISuperficialClient>>(
    `superficial/clients/one`,
    {
      params: {
        where: { id },
        relations: {
          // superficialContact: true,
          superficialAddress: true,
          client: true,
        },
      },
    }
  );
  return response.data;
}
export async function searchSubClientService(
  query: string
): Promise<IFilterData<ISuperficialClient>> {
  const api = client();
  const response = await api.get<IFilterData<ISuperficialClient>>(
    `superficial/clients?filter=${query}`
  );
  return response.data;
}
export async function createSubClient(registerSubclientParams: ISubclientRegisterParams) {
  const api = client();

  const response = await api.post("superficial/clients", registerSubclientParams);

  return response.data;
}

export async function updateSubClientService(updateSubclientParams: ISubclientUpdateParams) {
  const api = client();
  const response = await api.patch("superficial/clients", updateSubclientParams);
  return response.data;
}

export async function activeSubClients(id: string) {
  const api = client();
  const response = await api.post(`superficial/clients/${id}`);
  return response.data;
}

export async function deleteSubClients(id: string) {
  const api = client();
  const response = await api.delete(`superficial/clients/${id}`);
  return response.data;
}

export function downloadSubClientModel() {
  const fileType =
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
  const fileExtension = ".xlsx";

  const ws = XLSX.utils.json_to_sheet([
    {
      "Nome do sub-cliente": "",
      CNPJ: "",
      CEP: "",
      Rua: "",
      Número: "",
      Bairro: "",
      UF: "",
      Cidade: "",
      "Nome do estabelecimento": "",
      Latitude: "-23,538749",
      Longitude: "-46,902615",
    },
  ]);
  const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
  const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
  const data = new Blob([excelBuffer], { type: fileType });
  FileSaver.saveAs(data, "modelo" + fileExtension);
}

export async function convertExcel({
  file,
  clientId,
}: {
  file: File;
  clientId: string;
}): Promise<
  {
    client: {
      name: string;
      client: { id: string };
    };
    address: {
      cnpj: string;
      postalCode: string;
      street: string;
      number: string;
      district: string;
      uf: string;
      city: string;
      name: string;
    };
  }[]
> {
  const props = [
    "name",
    "cnpj",
    "postalCode",
    "street",
    "number",
    "district",
    "uf",
    "city",
    "name",
    "coordX",
    "coordY",
  ];

  const rows = await readXlsxFile(file);

  const headers = rows.shift();

  return rows.map((row) => {
    const client: any = {};
    const address: any = {};
    headers?.forEach((a, index) => {
      if (!a) {
        return;
      }
      if (index < 1) {
        client[props[index]] = row[index];
      } else {
        address[props[index]] = row[index];
      }
    });

    address.coordX = String(address.coordX).replace(",", ".");
    address.coordY = String(address.coordY).replace(",", ".");

    client.client = { id: clientId };
    return { client, address };
  });
}

export async function createMany(
  data: {
    client: {
      name: string;
      client: { id: string };
    };
    address: {
      cnpj: string;
      postalCode: string;
      street: string;
      number: string;
      district: string;
      uf: string;
      city: string;
      name: string;
    };
  }[]
) {
  const api = client();
  return await api.post("superficial/clients/many", { data });
}
